<template>
    <v-flex fill-height>
        <sidemainmenu/>
        <br />
        <v-progress-linear slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
        <v-alert :value="alertsuccess" color="success" icon="new_releases">
                {{ alertsmessage }}
        </v-alert>
        <v-alert :value="alerterror" color="error" icon="new_releases">
            <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
        </v-alert>
        <v-layout wrap justify-space-between>
            <v-card  class="mx-auto" min-width="100%">
            <v-card-title>
                <v-layout wrap justify-space-between>
                    <v-flex xs12 md2>
                        <v-menu v-model="dtSfromdate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="dtsfrdate" label="From Date" prepend-icon="event" readonly
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dtsfrdate" @input="dtSfromdate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 md2>
                        <v-menu v-model="dtStodate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="dtstdate" label="To Date" prepend-icon="event" readonly
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dtstdate" @input="dtStodate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 class="py-2">
                        <v-btn color="info" v-on:click="getData()">
                            <span>Search</span>
                            <v-icon>search</v-icon>
                        </v-btn>
                        <v-btn color="success" v-on:click="seen = !seen">
                            <span>Add New / List</span>
                            <v-icon>add</v-icon>
                        </v-btn>
                        <v-btn color="error" v-on:click="clearData()">
                            <span>Clear</span>
                            <v-icon>loop</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 md2>
                        <h3 class="py-4">EMPTY CONTAINER GOUT</h3>
                    </v-flex>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <v-card v-if="seen">
                    <v-card-title>
                        <export-excel
                            title = "VCFS EMPTY CONTAINER Gate Out"
                            :data   = "destuff_details">
                            <v-btn color="cyan">
                            <v-icon color="white">file_copy</v-icon>
                        </v-btn>
                        </export-excel>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="destuff_details" :search="search" class="elevation-1" :rows-per-page-items="[15, 50, 100, 500]">
                        <template v-slot:items="props">
                            <td>{{ props.index + 1 }}</td>
                            <td v-on:click="passPrint(props.item.gout_id)"><v-icon >print</v-icon></td>
                            <td class="text-xs-right">{{ props.item.cont_no }}</td>
                            <td class="text-xs-right">{{ props.item.size_type }}</td>
                            <td class="text-xs-right">{{ props.item.out_time }}</td>
                            <td class="text-xs-right">{{ props.item.pass_no }}</td>
                            <td class="text-xs-right">{{ props.item.cha }}</td>
                            <td class="text-xs-right">{{ props.item.line }}</td>
                            <td class="text-xs-right">{{ props.item.truck_no }}</td>
                            <td class="text-xs-right">{{ props.item.location }}</td>
                            <td class="text-xs-right">{{ props.item.party_name }}</td>
                            <td class="text-xs-right">{{ props.item.driver_name }}</td>
                            <td class="text-xs-right">{{ props.item.vessel }}</td>
                            <td class="text-xs-right">{{ props.item.voyage }}</td>
                            <td class="text-xs-right">{{ props.item.igm_no }}</td>
                            <td class="text-xs-right">{{ props.item.igm_date }}</td>
                            <td class="text-xs-right">{{ props.item.bl_no }}</td>
                            <td class="text-xs-right">{{ props.item.be_no }}</td>
                            <td class="text-xs-right">{{ props.item.be_date }}</td>
                            <td class="text-xs-right">{{ props.item.file_no }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card  v-else>
                    <v-form v-model="valid" ref="form">
                    <v-card-text class="mx-auto">
                        <v-container grid-list-xl>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtScont_no" label="Search By Container No." :rules="[(v) => !!v || 'Container No is required']" autofocus :counter="11" autocapitalize="words" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-btn  color="info" v-on:click="getSContData()">Search<v-icon right dark>search</v-icon></v-btn>
                                </v-flex>
                            </v-layout>
                            <v-card justify-center>
                                <v-card-text primary-title>
                                    <v-layout>
                                        <v-flex xs12 md3>
                                            <v-text-field :value="cont_list.bl_no" label="BL No" readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" cont_list.size_type" label="Size Type" readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" cont_list.gin_date" label="Gate In Date" readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" cont_list.customer" label="CHA" readonly></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" cont_list.line" label="Line" readonly ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" cont_list.package" label="Package" readonly ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" cont_list.weight" label="weight" readonly ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" cont_list.age" label="Age" readonly ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md3>
                                    <v-text-field v-model="txttruckno" label="Truck No" :rules="[(v) => !!v || 'Truck No is required']"></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-text-field v-model="txtparty_name" label="Party Name" :rules="[(v) => !!v || 'Party Name is required']"></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-select v-model="cbolocation" :items="location_list" item-value="id" label="To Yard" item-text="text"  :rules="[(v) => !!v || 'To Yard is required']"></v-select>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-text-field v-model="txtdriver_name" label="Driver Name" :rules="[(v) => !!v || 'Driver Name is required']"></v-text-field>        
                                </v-flex>
                            </v-layout>
                            <v-card v-if="is_chequepay" justify-center color="cyan lighten-4" class="white --text">
                                <v-card-text primary-title>
                                    <v-layout>
                                        <v-flex xs12 md3>
                                            <v-text-field v-model="txtcheque_no" label="Cheque No" required ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-menu v-model="dpcdate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="dtcdate" label="Cheque Date" prepend-icon="event" readonly
                                            v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dtcdate" @input="dpcdate = false"></v-date-picker>
                                        </v-menu>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field v-model="txtbank_name" label="Bank Name" required ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field v-model="txtamount" label="Amount"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                </v-flex>
                                <v-flex xs12 md4>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-btn color="success" v-bind:disabled="btnDisable" v-on:click="submitData()">Save</v-btn>
                                    <v-btn color="error" v-on:click="clearData()">Clear</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-form>
                </v-card>
            </v-card-text>
            </v-card>
        </v-layout>
    <br />
    <bottomfootermenus/>
    </v-flex>
</template>


<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import DatetimePicker from 'vuetify-datetime-picker';
import axios from 'axios';
    const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            if (term) {
              return items.filter(item => toLower(item.name).includes(toLower(term)))
            }

            return items
        }
  export default {
    name: 'destuffcargoout',
    data() {
        return {
            error: false,
            valid: false,
            alerterror: false,
            alertsuccess: false,
            alertsmessage: null,
            errors: null,
            seen: true,
            search: null,
            destuff_details: [],
            cont_list: [],
            location_list: [],
            bls: [],
            dtsfrdate: null,
            dtstdate: null,
            dtcdate: new Date().toISOString().substr(0, 10),
            dpcdate: false,
            activeVal: "Open",
            btnDisable: false,
            is_chequepay: false,
            loading: false,
            dtSfromdate: false,
            dtStodate: false,
            cont_no: null,
            bl_no: null,
            size_type: null,
            gin_date: null,
            cargo: null,
            line: null,
            package: null,
            weight: null,
            age: null,
            ruckno: null,
            eal_no: null,
            ine_seal: null,
            txtScont_no: null,
            txttruckno: null,
            txtparty_name: null,
            cbolocation: null,
            txtdriver_name: null,
            cbopayment_mode: null,
            txtcheque_no: null,
            txtamount: null,
            txtbank_name: null,
            crossDomain : true,
            xhrFields: {
                withCredentials: true
            },
            search: '',
            headers: [
              { text: 'S.No', sorting: false, align: 'left' },
              { text: 'Print', align: 'left', value: 'gout_id' },
              { text: 'Container No.', align: 'right', value: 'cont_no' },
              { text: 'Size Type', align: 'right', value: 'size_type' },
              { text: 'GOut Date', align: 'right', value: 'out_time' },
              { text: 'Pass No', align: 'right', value: 'pass_no' },
              { text: 'CHA', align: 'right', value: 'cha' },
              { text: 'line', align: 'right', value: 'line' },
              { text: 'Truck No', align: 'right', value: 'truck_no' },
              { text: 'To Yard', align: 'right', value: 'location' },
              { text: 'Party Name', align: 'right', value: 'party_name' },
              { text: 'Driver Name', align: 'right', value: 'driver_name' },
              { text: 'Vessel', align: 'right', value: 'vessel' },
              { text: 'Voyage', align: 'right', value: 'voyage' },
              { text: 'IGM', align: 'right', value: 'igm_no' },
              { text: 'IGM Date', align: 'right', value: 'igm_date' },
              { text: 'BL', align: 'right', value: 'bl_no' },
              { text: 'BE', align: 'right', value: 'be_no' },
              { text: 'BE Date', align: 'right', value: 'be_date' },
              { text: 'Work Order', align: 'right', value: 'file_no' }
            ],
            payment_mode: [
                {
                  text: 'CHEQUE',
                  id: 3
                },
                {
                  text: 'CREDIT',
                  id: 2
                },
                {
                  text: 'CASH',
                  id: 1
                }
            ]
        }
    },
    mounted:function(){
        this.getData(),
        this.getLocation()
    },
    components: {
        sidemainmenu,
        bottomfootermenus,
    },
    methods: {
        getData: function () {
            this.loading = true;
            if(this.dtsfrdate !== null && this.dtstdate !== null) {
                this.API_URL = this.$hostname + "/gateouts/ec?from_date=" + this.dtsfrdate + "&to_date=" + this.dtstdate
            } else {
                this.API_URL = this.$hostname + "/gateouts/ec?limit=15"
            }
            // this.API_URL = this.$hostname + "/gateouts/gateouts?limit=15"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.destuff_details = response.data;
            }, (error) => {
                this.loading = false;
                this.error = error;
                alert(this.error);
            })
        },
        searchOnTable () {
            this.state = searchByName(this.state, this.search)
        },
        submitData: function() {
            if(!this.$refs.form.validate()) {
                return false
            }
            this.btnDisable = true;
            this.loading = true;
            const data = {'crossDomain': true,
                          'cont_id': this.cont_list.cont_id,
                          'truck_no': this.txttruckno,
                          'party_name': this.txtparty_name,
                          'location': this.cbolocation,
                          'driver_name': this.txtdriver_name,
                          'created_by': localStorage.username }
            
            axios.post(this.$hostname + '/gateouts/ec', data,
                       { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
                 .then(response => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alertsuccess = "Container Added Successfully";
                    window.location.reload();
                 }, (error) => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alerterror = error.response.data.message;
                    window.location.reload();
                })
        },
        getSContData: function () {
            if (this.txtScont_no === null) {
                alert("Please Enter Container Number");
            } else {
                this.API_URL = this.$hostname + "/search_mt_containers/" + this.txtScont_no
                this.loading = true;
            }
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.cont_list = response.data.result;
                console.log(this.cont_list);
                this.loading = false;
            }, (error) => {
                this.errors = error.response.data.message;
                this.loading = false;
                alert(this.errors);

            })
        },
        onChange() {
            if (this.cbopayment_mode === 3) {
                this.is_chequepay = true;                
            } else {
                this.is_chequepay = false;
            }
        },
        getLocation: function () {
            this.API_URL = this.$hostname + "/combos/location"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.location_list = response.data;
            }, (error) => {
                this.error = true;
            })
        },
        clearData: function() {
            this.dtSfromdate = null;
            this.dtStodate = null;
            this.dtSfromdate = false;
            this.dtStodate = false;
            this.txtScont_no = null;
            this.txtsblno = null;
            this.txtsigm = null;
            this.txtsline = null;
            this.txtssizetype = null;
            this.txtsgindate = null;
            this.txtspackage = null;
            this.txtsweight = null;
            this.txtsage = null;
            this.txttruckno = null;
            this.txtparty_name = null;
            this.txtto_yard = null;
            this.txtdriver_name = null;
            this.txtseal_no = null;
            this.txtline_seal = null;
            this.cbopayment_mode = null;
        },
        passPrint: function(goutID) {
            let passPage = this.$router.resolve('/ecpass/' + goutID);
            window.open(passPage.href, '_blank');
        }
    }
  }
</script>

<style lang="stylus" scoped>
      .v-progress-circular
        margin: 1rem
    .loading-overlay 
        z-index: 10
        top: 0
        left: 0
        right: 0
        position: absolute
        width: 100%
        height: 100%
        background: rgba(255, 255, 255, 0.9)
        display: flex
        align-items: center
        justify-content: center
      
</style>
